import { Skeleton } from "ui";

const NAV_ITEM_COUNT = 8;

/**
 * Placeholder for the admin shell, shown while the user's permissions are being resolved.
 *
 * It mirrors the real layout (w-64 sidebar, h-16 header) so the chrome does not jump when the
 * permissions arrive. Deliberately renders no nav labels or routes: which modules exist is
 * itself permission-dependent, so guessing here would flash items the user cannot open.
 */
export function AdminLayoutSkeleton() {
  return (
    <div className="min-h-screen bg-gray-50">
      <aside className="fixed inset-y-0 left-0 z-40 w-64 border-r border-gray-200 bg-white">
        <div className="flex h-16 items-center border-b border-gray-200 px-4">
          <Skeleton className="h-8 w-32" />
        </div>

        <div className="space-y-2 p-4">
          {Array.from({ length: NAV_ITEM_COUNT }, (_, index) => (
            <div key={index} className="flex items-center gap-3 px-2 py-2">
              <Skeleton className="h-5 w-5 shrink-0 rounded" />
              <Skeleton className="h-4 w-full" />
            </div>
          ))}
        </div>
      </aside>

      <header className="fixed right-0 top-0 z-30 flex h-16 items-center justify-end gap-3 border-b border-gray-200 bg-white px-6 left-0 pl-64">
        <Skeleton className="h-8 w-8 rounded-full" />
        <Skeleton className="h-4 w-28" />
      </header>

      <main className="min-h-screen pl-64 pt-16">
        <div className="space-y-4 p-6">
          <Skeleton className="h-8 w-64" />
          <Skeleton className="h-4 w-96" />

          <div className="grid grid-cols-1 gap-4 pt-4 sm:grid-cols-2 lg:grid-cols-3">
            {Array.from({ length: 6 }, (_, index) => (
              <Skeleton key={index} className="h-32 w-full rounded-lg" />
            ))}
          </div>
        </div>
      </main>
    </div>
  );
}
